'use client'

import { Delete as DeleteIcon, Edit as EditIcon, Visibility as VisibilityIcon } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useState } from 'react'

export default function TableShowcase() {
    const [size, setSize] = useState<"small" | "medium">("small")

    const tableProductDataMock = [
        {
            id: 1,
            project: "Project A",
            job: "Job A",
            totalHours: 10,
            billable: 5,
            notBillable: 5,
        },
        {
            id: 2,
            project: "Project B",
            job: "Job B",
            totalHours: 20,
            billable: 15,
            notBillable: 5,
        },
        {
            id: 3,
            project: "Project C",
            job: "Job C",
            totalHours: 30,
            billable: 25,
            notBillable: 5,
        },
        {
            id: 4,
            project: "Project D",
            job: "Job D",
            totalHours: 40,
            billable: 35,
            notBillable: 5,
        },
        {
            id: 5,
            project: "Project E",
            job: "Job E",
            totalHours: 50,
            billable: 45,
            notBillable: 5,
        }
    ];
    
    return (
        <Card>
            <CardHeader title='Table Showcase' />
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Project</TableCell>
                                <TableCell>Job</TableCell>
                                <TableCell align="right">Total Hours</TableCell>
                                <TableCell align="right">Billable</TableCell>
                                <TableCell align="right">Not Billable</TableCell>
                                <TableCell align="center" width={1}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableProductDataMock.map((product) => (
                                <TableRow key={product.id}>
                                    <TableCell>
                                        <Typography variant="body1" component="div">
                                            {product.id}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" component="div">
                                            {product.project}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body1" component="div">
                                            {product.job}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Typography variant="body1" component="div">
                                            {product.totalHours}
                                        </Typography>
                                    </TableCell>        
                                    <TableCell align="right">
                                        <Typography variant="body1" component="div">
                                            {product.billable}
                                        </Typography>
                                    </TableCell>        
                                    <TableCell align="right">
                                        <Typography variant="body1" component="div">
                                            {product.notBillable}
                                        </Typography>
                                    </TableCell>        
                                    <TableCell align="center">
                                        {/*Pencil actions*/}
                                        <Box display="flex" justifyContent="center" marginX={5}>
                                            <IconButton>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton>
                                                <VisibilityIcon />
                                            </IconButton>
                                            <IconButton>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    )
}
